module.exports = __webpack_public_path__ + "static/service1-74e4cfad16f054c5d23629d4ff1ca7dc.png";